 export const allRoutes = [



    { name: "/organization/switcher", action: "Switch_Organization" },
    { name: "/organization/switcher/", action: "Switch_Organization" },
  
  
    { name: "/organization/data-grid-settings", action: "ORGANIZATION_ALL||GRID_CONFIGRATION" },
    { name: "/organization/data-grid-settings/view", action: "ORGANIZATION_ALL||GRID_CONFIGRATION" },
  
    { name: "/settings/change-password", action: "USER_RESET_PASSWORD" },
  
  
    { name: "/project-task", action: "VIEW_EMPLOYEE_TASK" },
    { name: "/project-task/view", action: "VIEW_EMPLOYEE_TASK" },
  
  
  
    { name: "/project-task/interns", action:  "VIEW_INTERN_TASK" },
    { name: "/project-task/interns/view", action: "VIEW_INTERN_TASK" },
  
  
    { name: "/project-task-categories", action: "VIEW_TASK_CATEGORY" },
    { name: "/project-task-categories/view", action: "VIEW_TASK_CATEGORY" },
  
  
  
    { name: "/project-task-subcategories", action: "VIEW_TASK_SUBCATEGORIES" },
    { name: "/project-task-subcategories/view", action: "VIEW_TASK_SUBCATEGORIES" },
  
    { name: "/project-task-schedule", action: "VIEW_EMPLOYEE_TASK_SCHEDULE" },
    { name: "/project-task-schedule/view", action: "VIEW_EMPLOYEE_TASK_SCHEDULE" },
  
    // { name: "/organization-configration/business-registration-type", action: "" },
  
    { name: "/project-task-schedule/interns", action: "VIEW_INTERN_TASK_SCHEDULE", },
    { name: "/project-task-schedule/interns/view", action: "VIEW_INTERN_TASK_SCHEDULE", },
  
  
  
    { name: "/project-task-schedule-timelog", action: "VIEW_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/view", action: "VIEW_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },
  
  
    { name: "/project-task-schedule-timelog/interns", action: "VIEW_INTERN_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/interns/edit", action: "EDIT_INTERN_TASK_SCHEDULE_TIMELOGS||EDIT_INTERN_TASK_SCHEDULE_TIEMLOGS", },
  
    // Client routes
    { name: "/client", action: "VIEW_ORGANIZATION_CLIENTS" },
    { name: "/client/view", action: "VIEW_ORGANIZATION_CLIENTS" },
  
    // Client Contact routes
    { name: "/client-contact", action: "VIEW_CLIENT_CONTACTS" },
    { name: "/client-contact/view", action: "VIEW_CLIENT_CONTACTS" },
  
    // Project routes
    { name: "/project", action: "VIEW_ORGANIZATON_PROJECTS" },
    { name: "/project/detail", action: "VIEW_ORGANIZATON_PROJECTS" },
  
    // Project Type routes
    { name: "/project-type", action: "VIEW_PROJECT_TYPE" },
    { name: "/project-type/view", action: "VIEW_PROJECT_TYPE" },
  
    // Project Category routes
    { name: "/project-category", action: "VIEW_PROJECT_CATEGORY" },
    { name: "/project-category/view", action: "VIEW_PROJECT_CATEGORY" },
  
    // Project Sub Category routes
    { name: "/project-sub-category", action: "VIEW_PROJECT_SUBCATAGORY" },
    { name: "/project-sub-category/view", action: "VIEW_PROJECT_SUBCATAGORY" },
  
    // Project Templates routes
    { name: "/project-templates", action: "VIEW_PROJECT_TEMPLATES" },
    { name: "/project-templates/view", action: "VIEW_PROJECT_TEMPLATES" },
  
    // Project Templates Milestone routes
    { name: "/project-templates-milestone", action: "VIEW_TEMPLATE_MILESTONES" },
    { name: "/project-templates-milestone/view", action: "VIEW_TEMPLATE_MILESTONES" },
  
    // Project Template Tasks routes
    { name: "/project-template-tasks", action: "VIEW_TEMPLATE_TASK" },
    { name: "/project-template-tasks/view", action: "VIEW_TEMPLATE_TASK" },
  
    // Project Team routes
    { name: "/project-team", action: "VIEW_PROJECT_TEAMS" },
    { name: "/project-team/view", action: "VIEW_PROJECT_TEAMS" },
  
    // Project Team Member routes
    { name: "/project-team-member", action: "VIEW_PROJECT_TEAM_MEMBERS" },
    { name: "/project-team-member/view", action: "VIEW_PROJECT_TEAM_MEMBERS" },
  
    // Project Milestone routes
    { name: "/project-milestone", action: "VIEW_PROJECT_MILESTONES" },
    { name: "/project-milestone/view", action: "VIEW_PROJECT_MILESTONES" },
  
    // Project Task Recurrence routes
    { name: "/project-task-recurrence", action: "VIEW_TASK_RECURRENCES" },
    { name: "/project-task-recurrence/view", action: "VIEW_TASK_RECURRENCES" },
  
    // Project Task Template routes
    { name: "/project-task-template", action: "VIEW_TASK_TEMPLATES" },
    { name: "/project-task-template/view", action: "VIEW_TASK_TEMPLATES" },
  
  
    // Project Task Type routes
    { name: "/project-task-type", action: "VIEW_TASK_TYPES" },
    { name: "/project-task-type/view", action: "VIEW_TASK_TYPES" },
  
    // My Profile route
    { name: "/my-profile", action: "VIEW_MY_PROFILE" },
  
    // Settings Update Credentials route
    { name: "/settings/update-credentials", action: "UPDATE_CREDENTIALS" },
  ];